import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './ServiceCard.css';

interface ServiceCardProps {
  icon: IconDefinition;
  title: string;
  description: string;
  linkTo: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  icon,
  title,
  description,
  linkTo
}) => {
  return (
    <div className="service-card">
      <div className="service-icon">
        <FontAwesomeIcon icon={icon} />
      </div>
      <h3 className="service-title">{title}</h3>
      <p className="service-description">{description}</p>
      <Link to={linkTo} className="service-link">
        Scopri di più <FontAwesomeIcon icon={faArrowRight} className="ms-1" />
      </Link>
    </div>
  );
};

export default ServiceCard;
